import React, { useState, useCallback } from 'react'
import { NextButton, PrevButton, usePrevNextButtons } from './ArrowButtons'
import { StepProgressCounter } from './StepProgressCounter'
import './Carousel.css'

const EmblaCarousel = ({
  children,
  hasButtons,
  hasProgress,
  onContinueButtonClick = null,
  emblaRef,
  emblaApi,
}) => {
  const [actualSlide, setActualSlide] = useState(0)

  const handleSlideChange = useCallback(() => {
    if (!emblaApi) return
    setActualSlide(emblaApi?.selectedScrollSnap())
  }, [emblaApi])

  // Track height changes when emblaApi is available
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons({ emblaApi, handleSlideChange })
  const showsContinueButton =
    typeof onContinueButtonClick === 'function' &&
    actualSlide === children.length - 1
  const ContinueButton = () => {
    return (
      <>
        {showsContinueButton && (
          <button
            onClick={onContinueButtonClick}
            className="embla__button embla__button--continue"
          >
            Continue
          </button>
        )}
      </>
    )
  }
  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {React.Children.map(children, (child, index) => (
            <div className="embla__slide" key={index}>
              {child}
            </div>
          ))}
        </div>
      </div>

      <div className="embla__widgets">
        {hasButtons && (
          <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
        )}

        {hasProgress && (
          <StepProgressCounter
            total={children.length}
            currentStep={actualSlide}
          />
        )}
        {hasButtons && !showsContinueButton && (
          <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
        )}
        <ContinueButton />
      </div>
    </div>
  )
}

export default EmblaCarousel
